module.exports = __webpack_public_path__ + "static/img/contract.ea72979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract.png
// module id = Fjsg
// module chunks = 1